/**
 * Build sorted license options for the About page License field.
 * Matches GSA openacr-editor: full SPDX list + "Invalid", sorted by label.
 */
import spdxLicenseList from "spdx-license-list";

const options = Object.keys(spdxLicenseList).map((id) => {
  const meta = spdxLicenseList[id];
  return {
    value: id,
    label: meta && meta.name ? `${meta.name} (${id})` : id,
  };
});
options.push({ value: "Invalid", label: "Invalid License" });
options.sort((a, b) => {
  const la = (a.label || "").toLowerCase();
  const lb = (b.label || "").toLowerCase();
  if (la < lb) return -1;
  if (la > lb) return 1;
  return 0;
});

export default options;
